module.exports = __webpack_public_path__ + "assets/816202d3ad0bd4f914869b76334e6a4b.svg";